export const CAPABILITY_CATEGORIES = [
  {
    id: "physical",
    title: "Physical",
    icon: "ri-body-scan-line",
    color: "orange",
    bgColor: "bg-orange-50",
    borderColor: "border-orange-200",
    iconColor: "text-orange-600",
    badgeColor: "bg-orange-100 text-orange-700",
    skills: [
      "Heavy Lifting (50+ lbs)",
      "Outdoor Work",
      "Standing Long Hours",
      "Manual Labor",
      "Climbing / Ladders",
      "Physical Endurance",
    ],
  },
  {
    id: "basic",
    title: "Basic Skills",
    icon: "ri-tools-line",
    color: "blue",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    iconColor: "text-blue-600",
    badgeColor: "bg-blue-100 text-blue-700",
    skills: [
      "Cleaning & Sanitizing",
      "Organizing & Sorting",
      "Basic Hand Tools",
      "Power Tools",
      "Painting",
      "Assembly Work",
    ],
  },
  {
    id: "access",
    title: "Access & Assets",
    icon: "ri-key-2-line",
    color: "green",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    iconColor: "text-green-600",
    badgeColor: "bg-green-100 text-green-700",
    skills: [
      "Own Car / Vehicle",
      "Pickup Truck",
      "Cargo Van",
      "Trailer / Towing",
      "Landscaping Equipment",
      "Cleaning Supplies",
    ],
  },
  {
    id: "digital",
    title: "Digital",
    icon: "ri-computer-line",
    color: "purple",
    bgColor: "bg-violet-50",
    borderColor: "border-violet-200",
    iconColor: "text-violet-600",
    badgeColor: "bg-violet-100 text-violet-700",
    skills: [
      "Basic Computer Skills",
      "Smartphone / Internet",
      "Social Media",
      "Data Entry",
      "Microsoft Office",
      "Customer Communication",
    ],
  },
];

export const JOB_CATEGORIES = [
  { id: "landscaping", label: "Landscaping", icon: "ri-plant-line" },
  { id: "moving", label: "Moving / Labor", icon: "ri-truck-line" },
  { id: "cleaning", label: "Cleaning", icon: "ri-service-line" },
  { id: "construction", label: "Construction", icon: "ri-building-2-line" },
  { id: "events", label: "Events", icon: "ri-calendar-event-line" },
  { id: "personal", label: "Personal Services", icon: "ri-user-heart-line" },
  { id: "driving", label: "Driving / Delivery", icon: "ri-car-line" },
  { id: "caregiving", label: "Caregiving", icon: "ri-heart-pulse-line" },
];
